import { render } from "./AboutQuantumRoadmap.vue?vue&type=template&id=e5d54bfc"
import script from "./AboutQuantumRoadmap.vue?vue&type=script&lang=js"
export * from "./AboutQuantumRoadmap.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__